
import { DefaultTheme } from 'styled-components';

const myTheme: DefaultTheme = {
  borderRadius: '5px',

  colors: {
    main: '#051937',
    secondary: '#A8EB12',
    white : "#fff",
    purple : "#53239C"
  },
};

export { myTheme };